let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1LMML")).then(() => parcelRequire('b8QVH'));